module.exports = __webpack_public_path__ + "static/media/speaker-signup-optimized.f53af1b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/05-why-gatsby/images/speaker-signup-optimized.jpg
// module id = 960
// module chunks = 0